export default [{
	"ID": "1",
	"Nome": "Solteiro"
},
    {
	"ID": "2",
	"Nome": "Casado"
},
    {
	"ID": "3",
	"Nome": "Separado"
},
    {
	"ID": "4",
	"Nome": "Divorciado"
},
    {
	"ID": "5",
	"Nome": "Viúvo"
}]